import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Typography from '../Typography';

const Breadcrumb = ({ crumbs = [], addClasses = '' }) => {
  const renderLink = (part, isLast, index) => {
    if (part.slug && !isLast) {
      return (
        <Link href={part.slug} className="typography typography-body" itemProp="item">
          <span itemProp="name">{part.text}</span>
          <meta itemProp="position" content={index + 1} />
        </Link>
      );
    }
    return (
      <Typography variant="body" addClasses={addClasses} itemProp="item">
        <span itemProp="name">{part.text}</span>
        <meta itemProp="position" content={index + 1} />
      </Typography>
    );
  };

  if (!crumbs?.length) return null;

  return (
    <div className="breadcrumb">
      <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
        {crumbs.map((part, index) => {
          const isLast = !(index < crumbs.length - 1);
          return (
            <li key={part.text} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              {index > 0 && <Typography addClasses={`separator ${addClasses}`} variant="body">/</Typography>}
              {renderLink(part, isLast, index)}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
  })),
  addClasses: PropTypes.string,
};

export default Breadcrumb;
